import { observable, action } from 'mobx';
import { Objects } from 'api';

class ObjectStore {
  @observable object;

  @observable fetchState;

  anketId;

  objectId;

  @action.bound
  async getObject(anketId, objectId) {
    if (this.anketId === anketId && this.objectId === objectId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Objects.getObject(anketId, objectId);
      this.object = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
      this.objectId = objectId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const objectStore = new ObjectStore();

export default objectStore;
